export const EMPLOYER_TRANSFER: string[] = ['LIRA', 'LRSP', 'RLSP', 'RRIF'];

export enum ACCOUNT_SOURCE {
  OTHFIN = 'OTHFIN',
  EMPLYR = 'EMPLYR',
  INTERNAL = 'INTERN',
}

export const REGEX_ACCOUNT_NUMBER: RegExp = /^[a-z|A-Z|0-9]{7}$/;
